import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { enforcingConsentManager, showCookiePreferences } from '../../../Osano';
import { T } from '../../../Translations';
import FooterDivider from '../FooterDivider';

interface Props {
  dividerClassName?: string;
}

function CookiePreferencesLink({ dividerClassName }: Props) {
  return enforcingConsentManager()
    .map((cm) => (
      <>
        <FooterDivider className={dividerClassName} />
        <button
          type="button"
          className="cursor-pointer bg-transparent p-0 font-sans"
          data-testid="footer_cookie-preferences-link"
          data-intercom-target="footer-cookie-preferences-button"
          onClick={() => {
            showCookiePreferences(cm);
          }}
        >
          <Typography
            className="text-neutral-900 underline hover:text-primary-500"
            variant="bodyMedium"
            fontWeight="semibold"
            as="span"
          >
            <T kind="Cookie preferences" />
          </Typography>
        </button>
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(CookiePreferencesLink);
